import { render, staticRenderFns } from "./StandaloneRelease.vue?vue&type=template&id=ac71d908&scoped=true&"
import script from "./StandaloneRelease.vue?vue&type=script&lang=js&"
export * from "./StandaloneRelease.vue?vue&type=script&lang=js&"
import style0 from "./StandaloneRelease.vue?vue&type=style&index=0&id=ac71d908&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ac71d908",
  null
  
)

export default component.exports